import { using, } from "rxjs";
export function refCountForever() {
    return (source) => {
        const connectable = source;
        let subscription = null;
        return using(() => {
            if (!subscription) {
                subscription = connectable.connect();
            }
            return {
                unsubscribe: () => { },
            };
        }, () => source);
    };
}
//# sourceMappingURL=refCountForever.js.map